export default class BackToTop {
	constructor() {
		document.addEventListener('click', e => {
			if (e.target) {
				if (e.target.closest('[data-back-to-top]')) {
					e.preventDefault();

					window.scroll({
						top: 0,
						behavior: 'smooth',
					});
				}
			}
		});
	}
}
